import React from 'react'
import { Doughnut, Bar } from 'react-chartjs-2';

export function ChartCollumns(props) {
  // const data = {
  //   labels: props.labels,
  //   datasets: props.datasets || [
  //     {
  //       label: props.title || '',
  //       backgroundColor: props.backgroundColor || 'rgba(255,165,0,1)',
  //       hoverBackgroundColor: 'rgba(255,99,132,0.4)',
  //       hoverBorderColor: 'rgba(255,99,132,1)',
  //       data: props.data
  //     }
  //   ]
  // };
    return (
      <div
        style={{
          width: '100%',
          height: '385px',
          padding: "5px"
        }}
      >
        <Bar
          data={props.datasets}
          width={100}
          height={50}
          options={{
            maintainAspectRatio: false,
            legend : { labels : {  fontColor : "#fff"}},
            scales: { 
              xAxes: [{
                  ticks: {
                      fontColor: "white",
                  }
              }],
              yAxes: [{
                  ticks: {
                      fontColor: "white",
                  }
              }]
          }
          }}
        />


      </div>
    )
  }

export function ChartDoughnut(props) {
  const data = {
    labels: props.labels,
    datasets: [{
      data: props.data,
      weight :22,
      backgroundColor: [
      'rgba(255,165,0,1)',
      'blue',
      'green',
      'red'
      ],
      hoverBackgroundColor: [
      '#FF6384',
      '#36A2EB',
      '#FFCE56'
      ]
    }]
  };
   
    return (
      <div
        style={{
          width: '100%',
          height: '300px',
          padding: "5px"
        }}
      >
        <Doughnut data={data} options={{ maintainAspectRatio : false, legend : { position: "bottom", labels : {  fontColor : "rgb(255, 255, 255)"}} }}/>


      </div>
    )
  }